
import HOCLoader from 'Components/Loader/HOCLoader';
import { Formik, Form } from 'formik';
import { Container, Grid, Paper, Box, Button, MenuItem, Typography } from '@material-ui/core';
import { LOGOUT } from 'ConstComponents';
import React, { useEffect, useState } from 'react';
import CircularProgress from '@material-ui/core/CircularProgress';
import { CheckAllProviderBalance as PROVIDER_CHECK_ALL_BALANCE } from 'Components/Api/ProviderApi';
import { GetTotalOutstandingBalance as SELECT_CASHCOLLACTION_SUMMARY } from 'Components/Api/CashCollectionAPI';
import { selectUserSummary as SELECT_DASHBOARD_USERSUMMARY } from 'Components/Api/UsersApi';
import { SelectSale as SELECT_SERVICE_WISE_SALE } from 'Components/Api/TransactionReportAPI';
import { SelectProviderSummary as SELECT_PROVIDER_SUMMARY } from 'Components/Api/ProviderPurchaseAPI';
import { VoucherModeBalance as SELECT_VOUCHER_MODE_SUMMARY } from 'Components/Api/VoucherAPI';
import { Select as SELECT_DASHBOARD_DATA } from 'Components/Api/DashboardApi';
import DashBoardUserSummary from 'Pages/InnerPages/Voucher/VoucherSummary/DashBoardUserSummary';
import DashBoardAdminTransactionDetails from 'Pages/InnerPages/Voucher/VoucherSummary/DashBoardAdminTransactionDetails';
import ProvidersSummary from 'Pages/InnerPages/Voucher/VoucherSummary/ProvidersSummary';
import { MaterialDatePickerField } from 'Components/Inputes/MaterialDatePickerField';
import { commonStyle } from 'Components/CustomMaterialStyleSheets/CommonStyleSheet';
import { useHistory } from 'react-router';
import { PrimaryButton } from 'Components/Inputes/CustomButton';
import Accordion from '@material-ui/core/Accordion';
import HOCAccordion from 'Components/CustomAccordion/HOCAccordion';
import ModeSummary from './VoucherSummary/ModeSummary';
import { PRIMARY_COLOR } from 'Config';

export function BalanceSheetReport() {
    const classes = commonStyle();
    const history = useHistory();
    const [ProviderSummraylist, setProviderSummraylist] = useState([]);
    const [isError, setIsError] = useState(false);
    const [severity, setSeverity] = useState('success');
    const [responseMessage, setResponseMessage] = useState('');
    const [loadingOpen, setLoadingOpen] = useState(false);
    const [UserSummraylist, setUserSummraylist] = useState([]);
    const [TodaySummarylist, setTodaySummarylist] = useState([]);
    const [isTotalOutstanding, SetTotalOutstanding] = useState([]);
    const [ServicewiseSale, setServicewiseSale] = useState([]);
    const [isModeDetails, setModeDetails] = useState([]);
    const [loading, setLoading] = useState(false);
    const CustomAccordion = HOCAccordion(Accordion);
    const CustomContainer = HOCLoader(Container);
    useEffect(() => {
        setLoadingOpen(true);
        selectUserSummary();
        selectProviderSummary();
        selectServicewiseSale();
        selectTotalOutstandingSummary();
        selectVoucherModeBalanceSummary();
        select();
        setLoadingOpen(false);
    }, []);
    const [ModelObj] = useState({
        FromDate: new Date(),
        ToDate: new Date(),
        Date: new Date()
    });
    const [formObject, setFormObject] = useState({
        TotalSuccessAmount: 0,
        TotalFailedAmount: 0,
        TotalOutStandingCount: 0,
        TotalOutStanding: 0,
        TotalAdminCommission: 0,
        TotalAdminSurcharge: 0,
        AdminCommissionProfit: 0,
        AdminSurchargeProfit: 0,
    });
    const currentDate = new Date();
    const minDate = new Date();
    minDate.setMonth(currentDate.getMonth() - 3);

    const selectProviderSummary = async () => {
        var inputObj = {
            Date: new Date()
        };
        var requestObj = JSON.stringify(inputObj);
        setProviderSummraylist([]);
        const response = await SELECT_PROVIDER_SUMMARY(requestObj);

        if (!response.isAuthorized) LOGOUT();

        if (!response.status) {
            setIsError(true);
            setResponseMessage(response.data);
            setSeverity('error');
            return;
        }
        var data = JSON.parse(response.data);
        if (data !== null || data !== undefined) setProviderSummraylist(data);
    };
    const selectVoucherModeBalanceSummary = async () => {
        var inputObj = {
            Date: new Date()
        };
        var requestObj = JSON.stringify(inputObj);
        setProviderSummraylist([]);
        const response = await SELECT_VOUCHER_MODE_SUMMARY(requestObj);

        if (!response.isAuthorized) LOGOUT();

        if (!response.status) {
            setIsError(true);
            setResponseMessage(response.data);
            setSeverity('error');
            return;
        }
        var data = JSON.parse(response.data);
        setModeDetails(data)
    };
    const selectServicewiseSale = async () => {
        var inputObj = {
            FromDate: new Date(),
            ToDate: new Date(),
        };
        setServicewiseSale([]);

        let requestObj = JSON.stringify(inputObj);
        const response = await SELECT_SERVICE_WISE_SALE(requestObj);

        setLoadingOpen(false);

        if (!response.isAuthorized) LOGOUT();
        if (!response.status) {
            return;
        }

        var data = JSON.parse(response.data);

        if (data.list !== null || data.list !== undefined)
            setServicewiseSale(data.list);

        setLoadingOpen(false);
    };
    const selectUserSummary = async () => {
        var inputObj = {
            Date: new Date()
        };
        var requestObj = JSON.stringify(inputObj);
        setUserSummraylist([]);
        const response = await SELECT_DASHBOARD_USERSUMMARY(requestObj);

        if (!response.isAuthorized) LOGOUT();

        if (!response.status) {
            setIsError(true);
            setResponseMessage(response.data);
            setSeverity('error');
            return;
        }
        var data = JSON.parse(response.data);
        if (data !== null || data !== undefined) setUserSummraylist(data);
    };
    const selectTotalOutstandingSummary = async () => {
        var inputObj = {
            Date: new Date()
        };
        var requestObj = JSON.stringify(inputObj);
        setUserSummraylist([]);
        const response = await SELECT_CASHCOLLACTION_SUMMARY(requestObj);

        if (!response.isAuthorized) LOGOUT();

        if (!response.status) {
            setIsError(true);
            setResponseMessage(response.data);
            setSeverity('error');
            return;
        }
        var data = JSON.parse(response.data);
        var data = JSON.parse(response.data);
        setFormObject((prevFormObject) => ({
            ...prevFormObject,
            TotalOutStanding: data.Outstanding,
            TotalOutStandingCount: data.Count

        }));
        if (data !== null || data !== undefined) SetTotalOutstanding(data);
    };
    const select = async () => {
        var inputObj = {
            Date: new Date()
        };
        var requestObj = JSON.stringify(inputObj);
        const response = await SELECT_DASHBOARD_DATA(requestObj);
        setLoadingOpen(false);

        if (!response.isAuthorized) LOGOUT();

        if (!response.status) {
            setIsError(true);
            setSeverity('error');
            setResponseMessage(response.data);

            return;
        }

        var data = JSON.parse(response.data);
        setFormObject((prevFormObject) => ({
            ...prevFormObject,
            TotalSuccessAmount: data.TotalSuccessAmount,
            TotalFailedAmount: data.TotalFailedAmount,
            TotalAdminCommission: data.TotalAdminCommission,
            TotalAdminSurcharge: data.TotalAdminSurcharge,
            AdminCommissionProfit: data.AdminCommissionProfit,
            AdminSurchargeProfit: data.AdminSurchargeProfit,
        }));
    };
    const submithandle = async (values, { setSubmitting, resetForm }) => {
        if (values.Date == null) return;

        var inputObj = {
            Date: values.Date,
            FromDate: values.FromDate,
            ToDate: values.ToDate,
            UserID: 0
        };

        var requestObj = JSON.stringify(inputObj);
        setTodaySummarylist([]);
        setServicewiseSale([]);
        setUserSummraylist([]);
        setProviderSummraylist([]);

        setLoadingOpen(true);

        const response = await SELECT_SERVICE_WISE_SALE(requestObj);
        var data = JSON.parse(response.data);
        if (data !== null || data !== undefined) setTodaySummarylist(data);

        const responseService = await SELECT_SERVICE_WISE_SALE(requestObj);

        var dataService = JSON.parse(responseService.data);
        if (dataService.list !== null || dataService.list !== undefined)
            setServicewiseSale(dataService.list);

        const responseUser = await SELECT_DASHBOARD_USERSUMMARY(requestObj);

        var dataUser = JSON.parse(responseUser.data);
        if (dataUser !== null || dataUser !== undefined)
            setUserSummraylist(dataUser);

        const responseProvider = await SELECT_PROVIDER_SUMMARY(requestObj);

        var dataProvider = JSON.parse(responseProvider.data);
        if (dataProvider !== null || dataProvider !== undefined)
            setProviderSummraylist(dataProvider);


        const responseCard = await SELECT_DASHBOARD_DATA(requestObj);

        var dataCard = JSON.parse(responseCard.data);
        setFormObject((prevFormObject) => ({
            ...prevFormObject,
            TotalSuccessAmount: dataCard.TotalSuccessAmount,
            TotalFailedAmount: dataCard.TotalFailedAmount,
            TotalAdminCommission: dataCard.TotalAdminCommission,
            TotalAdminSurcharge: dataCard.TotalAdminSurcharge,
            AdminCommissionProfit: dataCard.AdminCommissionProfit,
            AdminSurchargeProfit: dataCard.AdminSurchargeProfit,
        }));

        setLoadingOpen(false);
        setSubmitting(false);
    };

    const CheckAllBalance = async () => {
        setLoadingOpen(true);
        setIsError(false);
        const response = await PROVIDER_CHECK_ALL_BALANCE();
        setLoadingOpen(false);
        if (!response.isAuthorized) LOGOUT();
        setSeverity('success');
        setResponseMessage(response.data);

        if (!response.status) setSeverity('error');
        setIsError(true);
        selectProviderSummary();
    };
    return (

        <CustomContainer
            isLoading={loading}
            isError={isError}
            alertMessage={responseMessage}
            severity={severity}
            onCloseCallback={(alertState) => {
                setIsError(alertState);
            }}
        > <Formik
                initialValues={ModelObj}
                onSubmit={submithandle}
                resetForm={ModelObj}
                render={({
                    values,
                    setFieldValue,
                    handleChange,
                    handleSubmit
                }) => {
                    return (
                        <Form>
                            <Grid item xs={12}>
                                <Grid container spacing={2}>
                                    <Grid item xs={12} sm={12} md={2} lg={2}>
                                        <MaterialDatePickerField
                                            name="FromDate"
                                            label="FromDate"
                                            minDate={minDate}
                                            maxDate={currentDate}
                                        />
                                    </Grid>
                                    <Grid item xs={12} sm={12} md={2} lg={2}>
                                        <MaterialDatePickerField
                                            name="ToDate"
                                            label="ToDate"
                                            minDate={minDate}
                                            maxDate={currentDate}
                                        />
                                    </Grid>
                                    <Grid item xs={12} sm={12} md={2} lg={2}>
                                        <PrimaryButton
                                            type="submit"
                                            title="Search"
                                            className={
                                                classes.CustomPrimaryButtonStyle
                                            }
                                            style={{
                                                marginTop: '11px'
                                            }}
                                            fullWidth
                                            disabled={loadingOpen}
                                        >
                                            Search
                                        </PrimaryButton>

                                        {loadingOpen && (
                                            <CircularProgress
                                                size={24}
                                                className={
                                                    classes.buttonProgress
                                                }
                                            />
                                        )}
                                    </Grid>
                                    <Grid
                                        item
                                        xs={12}
                                        sm={12}
                                        md={4}
                                        lg={4}
                                    ></Grid>
                                    <Grid item xs={12} sm={12} md={2} lg={2}>
                                        <Box className={classes.flexReverse}>
                                            <Button
                                                variant="contained"
                                                color="primary"
                                                className={
                                                    classes.CustomPrimaryButtonStyle
                                                }
                                                onClick={() => {
                                                    CheckAllBalance();
                                                }}
                                            >
                                                Refresh Bal
                                            </Button>
                                        </Box>
                                    </Grid>
                                </Grid>
                            </Grid>
                        </Form>
                    );
                }}
            />
            <Grid item xs={12}>
                <Paper style={{ padding: '20px', }}>
                    <Grid item xs={12}>
                        <Grid container spacing={3}>
                            <Grid item xs={12} sm={12} md={4} lg={4} xl={4}>
                                <Box style={{ padding: '12px', marginBottom: '20px', background: '#f1f1f1', borderRadius: '6px' }}>
                                    <Typography sx={{ fontSize: "16px", fontWeight: "600" }} variant='h6'>Mode Balance</Typography>
                                    <ModeSummary data={isModeDetails} />
                                </Box>
                                <div style={{
                                    background: PRIMARY_COLOR(),
                                    color: '#fff',
                                    padding: '16px',
                                    borderRadius: '6px'
                                }}>
                                    <DashBoardAdminTransactionDetails
                                        style={{ padding: '16px' }}
                                        transactionDetails={formObject}
                                    />
                                </div>
                            </Grid>
                            <Grid item xs={12} sm={12} md={4} lg={4} xl={4}>
                                <Box style={{ padding: '12px', marginBottom: '20px', background: '#f1f1f1', borderRadius: '6px' }}>
                                    <DashBoardUserSummary UserSummary={UserSummraylist} />
                                </Box>
                                <Box style={{ padding: '12px', marginBottom: '20px', color: '#fff', background: PRIMARY_COLOR(), borderRadius: '6px' }}>
                                    <Typography style={{ fontSize: "20px", fontWeight: "600", color: '#fff' }} variant='h6'>Sale</Typography>

                                    {ServicewiseSale && ServicewiseSale.map(
                                        (
                                            { ServiceName, SuccessAmt },
                                            index
                                        ) => {
                                            return (
                                                <Box style={{ borderBottom: '1px solid #fff', padding: '10px' }} key={`serviceDiv-${index}`}>
                                                    <Box style={{ fontSize: '16px', }}>
                                                        <Grid container spacing={2}>
                                                            <Grid item xs={12} sm={12} md={6} lg={6} xl={6}>
                                                                {ServiceName}
                                                            </Grid>
                                                            <Grid item xs={12} sm={12} md={6} lg={6} xl={6}>
                                                                {SuccessAmt}
                                                            </Grid>
                                                        </Grid>
                                                    </Box>
                                                </Box>
                                            );
                                        }
                                    )}
                                </Box>
                            </Grid>
                            <Grid item xs={12} sm={12} md={4} lg={4} xl={4}>
                                <div className={classes.dashboard_right_panel}>
                                    <ProvidersSummary data={ProviderSummraylist} />
                                </div>
                            </Grid>
                        </Grid>
                    </Grid>
                </Paper>
            </Grid>
        </CustomContainer>
    )
}
